<template>
  <div v-if="store.loaded && !store.showMobile" class="wrapper">
    <div class="phone">
      <a :href="'tel:' + store.phone.replaceAll(' ', '')">{{ store.phone }}</a>
    </div>
    <div>
      <router-link to="/about" :class="['text-left', {'hide-text': $route.name === 'about'}]"
        v-text="'<-- Кто мы?'"
      />
      <a @click="$router.go(-1)" 
        :class="['text-right', 'align-right', {'hide-text': $route.name !== 'about'}]"
        v-text="'Всё там -->'"
      />
    </div>
    <div>
      <div class="red-bar"/>
      <router-link to="/" class="logo">
        <img src="/images/peppers.svg">
      </router-link>
    </div>
  </div>
  <!-- ================ -->
  <!-- Мобильная версия -->
  <!-- ================ -->
  <div v-if="store.loaded && store.showMobile" class="mobile-wrapper">
    <div class="mobile-red-bar"/>
    <router-link to="/" class="mobile-logo">
      <img src="/images/peppers.svg">
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMainStore } from '../store'
export default defineComponent({
  name: 'LogoBlock',
  data () {
    return {
      store: useMainStore(),
    }
  }
})
</script>

<style scoped>

.wrapper {
  position: relative;
  /* width: 30rem; */
  height: 40rem;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  padding: 5rem;
}

.red-bar {
  position: absolute;
  bottom: 5rem;
  left: -1rem;
  width: 29rem;
  height: 9.2rem;
  background-color: var(--red);
  transform: rotate(-6.2deg);
}

.phone {
  pointer-events: all;
  font-size: 1.8rem;
}

.text-left, .text-right {
  position: absolute;
  pointer-events: all;
  cursor: pointer;
  font-size: 1.8rem;
  transition: all .3s ease-in-out;
}

.text-left:hover {
  transform: translateX(-2rem);
  padding-right: 2rem;
  transition: all .3s ease-in-out;
}

.text-right:hover {
  transition: all .3s ease-in-out;
  padding-left: 2rem;
  transform: translateX(2rem);
}

.hide-text {
  pointer-events: none;
  opacity: 0;
  transition: all .5s ease-in-out;
}

.align-right {
  right: 5rem;
}

.logo {
  pointer-events: all;
  position: fixed;
  padding-top: 1rem;
  width: calc(50vw - 10rem);
  max-width: 26rem;
  min-width: 21rem;
}

/* ================ */
/* Мобильная версия */
/* ================ */
.mobile-wrapper {
  position: relative;
  width: 18rem;
  max-width: 50%;
}

.mobile-red-bar {
  position: absolute;
  left: -3rem;
  top: 1.8rem;
  width: 14rem;
  aspect-ratio: 10/2.7;  
  background-color: var(--red);
  transform: rotate(-6.2deg);
}

.mobile-logo {
  pointer-events: all;
  position: absolute;
  top: 1.6rem;
  left: 2rem;
  width: 10rem;
}

</style>